export default (app) => {
  let connected = false;
  let updating = Promise.resolve();
  let pendingUpdates = 0;
  // Collections catch up one at a time so a reconnect does not flood a weak link.
  const runUpdates = (collection) => {
    pendingUpdates++;
    updating = updating
      .catch(() => {})
      .then(() => collection.updates())
      .finally(() => pendingUpdates--);
    return updating;
  };
  const collections = [];
  let pollTimer;

  app.on("init", () => {
    ({ connected } = app.connection);
    app.connection.on("connection", async (query) => {
      const reconnect = !connected && query.connected;
      ({ connected } = query);
      clearInterval(pollTimer);
      if (!connected) return;
      if (app.settings.clearDbOnConnect && reconnect) await app.database.clearCache();
      collections.forEach(runUpdates);
      // The HTTPS fallback has no push channel for database updates.
      // A pass still running on a slow link is not queued again.
      if (query.fallback) pollTimer = setInterval(() => !pendingUpdates && collections.forEach(runUpdates), 30000);
    });
  });

  app.database.on("init", ({ collection, contentType }) => {
    const send = (action, query) =>
      app.connection
        .emit({ type: "database", action, contentType: contentType.machinename, query })
        // A request without a reply was lost with the connection and is handled as offline.
        // A failed server handler is a rejected request, its data must not reach the cache.
        .then((event) =>
          event.offline
            ? { ...query, offline: true }
            : event.error
              ? { ...query, data: undefined, error: event.error }
              : event.query,
        );

    ["find", "get", "size"].forEach((event) => {
      collection.on(event, 900, (query) =>
        query.data ? undefined : !connected ? { ...query, offline: true } : send(event, query),
      );
    });

    collection.on("delete", 2700, (query) => (!connected ? { ...query, offline: true } : send("delete", query)));

    collection.on("save", 2700, (query) => (!connected ? { ...query, offline: true } : send("save", query)));

    collection.on("search", 1700, (query) =>
      query.inCache ? undefined : !connected ? { ...query, offline: true } : send("search", query),
    );

    collection.on("updates", (query) => query.date && send("updates", query));
    collection.on("update", 200, (query) => ({ ...query, offline: !connected }));

    app.connection.on("database", (event) => {
      if (event.contentType !== contentType.machinename || !["update"].includes(event.action)) return;

      collection[event.action](event.query);
    });

    collections.push(collection);
    collection.on("init", -100, () => {
      if (app.connection.connected) runUpdates(collection);
    });
  });
};
